import { atom } from 'recoil';

/**
 * 個別画面用アラートダイアログの表示状態を管理する型
 * API呼び出し失敗時などに個別のエラーダイアログを表示する場合に使用する。
 */
type Alert = {
  /** ダイアログの表示状態 */
  isOpen: boolean;
  /** エラーが発生したAPIの種別（エラーメッセージの出し分けに使用） */
  apiType: string;
};

/**
 * 個別画面用アラートダイアログのステート
 * alertGlobalStateとは異なり、各画面固有のエラー表示に使用する。
 */
const alertState = atom<Alert>({
  key: 'alert',
  default: {
    isOpen: false,
    apiType: '',
  },
});

export default alertState;
